window.log = function() {
    log.history = log.history || [];
    log.history.push(arguments);
    if (this.console) {
        arguments.callee = arguments.callee.caller;
        console.log(Array.prototype.slice.call(arguments))
    }
}; (function(a) {
    function b() {}
    for (var c = "assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,time,timeEnd,trace,warn".split(","), d; d = c.pop();) a[d] = a[d] || b
})(window.console = window.console || {}); (function(a) {
    function c(a) {
        return typeof a == "object" ? a: {
            top: a,
            left: a
        }
    }
    var b = a.scrollTo = function(b, c, e) {
        a(window).scrollTo(b, c, e)
    };
    b.defaults = {
        axis: "xy",
        duration: parseFloat(a.fn.jquery) >= 1.3 ? 0: 1
    };
    b.window = function(b) {
        return a(window)._scrollable()
    };
    a.fn._scrollable = function() {
        return this.map(function() {
            var b = this,
            c = !b.nodeName || a.inArray(b.nodeName.toLowerCase(), ["iframe", "#document", "html", "body"]) != -1;
            if (!c) return b;
            var e = (b.contentWindow || b).document || b.ownerDocument || b;
            return a.browser.safari || e.compatMode == "BackCompat" ? e.body: e.documentElement
        })
    };
    a.fn.scrollTo = function(e, f, g) {
        if (typeof f == "object") {
            g = f;
            f = 0
        }
        if (typeof g == "function") g = {
            onAfter: g
        };
        if (e == "max") e = 9e9;
        g = a.extend({},
        b.defaults, g);
        f = f || g.speed || g.duration;
        g.queue = g.queue && g.axis.length > 1;
        if (g.queue) f /= 2;
        g.offset = c(g.offset);
        g.over = c(g.over);
        return this._scrollable().each(function() {
            function r(a) {
                i.animate(o, f, g.easing, a &&
                function() {
                    a.call(this, e, g)
                })
            }
            var h = this,
            i = a(h),
            l = e,
            m,
            o = {},
            q = i.is("html,body");
            switch (typeof l) {
            case "number":
            case "string":
                if (/^([+-]=)?\d+(\.\d+)?(px|%)?$/.test(l)) {
                    l = c(l);
                    break
                }
                l = a(l, this);
            case "object":
                if (l.is || l.style) m = (l = a(l)).offset()
            }
            a.each(g.axis.split(""),
            function(a, c) {
                var d = c == "x" ? "Left": "Top",
                e = d.toLowerCase(),
                f = "scroll" + d,
                j = h[f],
                n = b.max(h, c);
                if (m) {
                    o[f] = m[e] + (q ? 0: j - i.offset()[e]);
                    if (g.margin) {
                        o[f] -= parseInt(l.css("margin" + d)) || 0;
                        o[f] -= parseInt(l.css("border" + d + "Width")) || 0
                    }
                    o[f] += g.offset[e] || 0;
                    if (g.over[e]) o[f] += l[c == "x" ? "width": "height"]() * g.over[e]
                } else {
                    var p = l[e];
                    o[f] = p.slice && p.slice( - 1) == "%" ? parseFloat(p) / 100 * n: p
                }
                if (/^\d+$/.test(o[f])) o[f] = o[f] <= 0 ? 0: Math.min(o[f], n);
                if (!a && g.queue) {
                    if (j != o[f]) r(g.onAfterFirst);
                    delete o[f]
                }
            });
            r(g.onAfter)
        }).end()
    };
    b.max = function(b, c) {
        var e = c == "x" ? "Width": "Height",
        f = "scroll" + e;
        if (!a(b).is("html,body")) return b[f] - a(b)[e.toLowerCase()]();
        var g = "client" + e,
        h = b.ownerDocument.documentElement,
        i = b.ownerDocument.body;
        return Math.max(h[f], i[f]) - Math.min(h[g], i[g])
    }
})(jQuery);

/*!
 * jQuery imagesLoaded plugin v1.0.4
 * http://github.com/desandro/imagesloaded
 *
 * MIT License. by Paul Irish et al.
 */

(function($, undefined) {

  // $('#my-container').imagesLoaded(myFunction)
  // or
  // $('img').imagesLoaded(myFunction)

  // execute a callback when all images have loaded.
  // needed because .load() doesn't work on cached images

  // callback function gets image collection as argument
  //  `this` is the container

  $.fn.imagesLoaded = function( callback ) {
    var $this = this,
        $images = $this.find('img').add( $this.filter('img') ),
        len = $images.length,
        blank = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==',
        loaded = [];

    function triggerCallback() {
      callback.call( $this, $images );
    }

    function imgLoaded( event ) {
      if ( event.target.src !== blank && $.inArray( this, loaded ) == -1 ){
        loaded.push(this);
        if ( --len <= 0 ){
          setTimeout( triggerCallback );
          $images.unbind( '.imagesLoaded', imgLoaded );
        }
      }
    }

    if ( !len ) {
      triggerCallback();
    }

    $images.bind( 'load.imagesLoaded error.imagesLoaded',  imgLoaded ).each( function() {
      // cached images don't fire load sometimes, so we reset src.
      var src = this.src;
      // webkit hack from http://groups.google.com/group/jquery-dev/browse_thread/thread/eee6ab7b2da50e1f
      // data uri bypasses webkit log warning (thx doug jones)
      this.src = blank;
      this.src = src;
    });

    return $this;
  };
})(jQuery);

(function(a) {
    a.fn.equalHeightColumns = function(b) {
        var c,
        d;
        b = a.extend({},
        a.equalHeightColumns.defaults, b);
        d = a(this);
        c = b.height;
        a(this).each(function() {
            if (b.children) d = a(this).children(b.children);
            if (!b.height) {
                if (b.children) {
                    d.each(function() {
                        if (a(this).height() > c) c = a(this).height()
                    })
                } else {
                    if (a(this).height() > c) c = a(this).height()
                }
            }
        });
        if (b.minHeight && c < b.minHeight) c = b.minHeight;
        if (b.maxHeight && c > b.maxHeight) c = b.maxHeight;
        d.animate({
            height: c
        },
        b.speed);
        return a(this)
    };
    a.equalHeightColumns = {
        version: 1,
        defaults: {
            children: false,
            height: 0,
            minHeight: 0,
            maxHeight: 0,
            speed: 0
        }
    }
})(jQuery)
